__turbopack_context__.v({
  "mobileWidth": "StatusToastNotification-module-scss-module__qQx4Ga__mobileWidth",
});
